import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AbsenceChangesService } from '@core/api/absences/absence-changes.service';

import { API_BASE_URL } from 'app/core/api/api.tokens';
import { joinUrl } from 'app/core/api/api.utils';
import { AbsenceRequest, AbsenceRequestsQuery } from './absence-requests.types';

@Injectable({ providedIn: 'root' })
export class AbsenceRequestsService {
    private readonly changes = inject(AbsenceChangesService);
    private _http = inject(HttpClient);
    private _apiBaseUrl = inject(API_BASE_URL);

    getRequests(query: AbsenceRequestsQuery): Observable<AbsenceRequest[]> {
        let params = new HttpParams().set('year', String(query.year));

        if (query.status) {
            params = params.set('status', query.status);
        }

        for (const id of query.employeeIds ?? []) {
            params = params.append('employeeIds', id);
        }

        if (query.onlyMyEmployees !== undefined) {
            params = params.set('onlyMyEmployees', String(query.onlyMyEmployees));
        }

        for (const id of query.departmentIds ?? []) {
            params = params.append('departmentIds', id);
        }

        for (const id of query.locationIds ?? []) {
            params = params.append('locationIds', id);
        }

        return this._http.get<AbsenceRequest[]>(joinUrl(this._apiBaseUrl, '/absences'), { params });
    }

    approve(id: string): Observable<void> {
        return this._http.post<void>(joinUrl(this._apiBaseUrl, `/absences/${id}/approve`), {}).pipe(
            tap(() => this.changes.notify({ kind: 'approved', id }))
        );
    }

    reject(id: string, rejectionReason: string): Observable<void> {
        return this._http.post<void>(joinUrl(this._apiBaseUrl, `/absences/${id}/reject`), { rejectionReason }).pipe(
            tap(() => this.changes.notify({ kind: 'rejected', id }))
        );
    }
}
